<template>
  <ODialog ref="dialog" hideWhenLoading :maxWidth="700">
    <v-card v-if="row != null">
      <ODialogBar title="Histórico do Teclado" @close="dismiss" />
      <v-card-text class="pa-3">
        <ValuesReferenceDialog ref="valuesReferenceDialog" />
        <v-form ref="theForm" v-model="isValid">
          <div class="d-flex flex-row">
            <OSelect
              class="w-1/2 pa-3"
              v-model="row.type"
              label="Tipo do registro"
              placeholder="Selecione..."
              :items="types"
              :rules="[isSet]"
            />
            <ODateTimeInput2
              class="w-1/2 pa-3"
              label="Data/hora"
              v-model="row.timestamp"
              :clearable="false"
            />
          </div>

          <div class="d-flex flex-row">
            <OAutocomplete
              class="w-full pa-3"
              v-model="row.vehicleId"
              label="Veículo"
              placeholder="Selecione..."
              :items="vehicles"
              :rules="[isSet]"
            />
          </div>

          <div class="d-flex flex-row">
            <OAutocomplete
              class="w-1/2 pa-3"
              v-model="row.technicianId"
              label="Técnico"
              placeholder="Selecione..."
              :items="techs"
              :rules="[isSet]"
            />
            <div class="w-1/2 pa-3 d-flex items-center justify-stretch">
              <OMoneyInput
                class="grow-1"
                v-model="row.techValue"
                label="Valor para o técnico"
                :rules="[isSet]"
              />
              <v-btn icon @click="showTechValues">
                <v-icon>mdi-notebook</v-icon>
              </v-btn>
            </div>
          </div>

          <div class="d-flex flex-row">
            <OAutocomplete
              class="w-1/2 pa-3"
              v-model="row.costCenterId"
              label="Centro de Custo"
              placeholder="Selecione..."
              :items="costCenters"
              :rules="[isSet]"
            />
            <div class="w-1/2 pa-3 d-flex items-center justify-stretch">
              <OMoneyInput
                class="grow-1"
                v-model="row.costCenterValue"
                label="Valor para o centro de custo"
                :rules="[isSet]"
              />
              <v-btn icon @click="showCostCenterValues">
                <v-icon>mdi-notebook</v-icon>
              </v-btn>
            </div>
          </div>

          <div class="d-flex flex-row">
            <OTextarea
              class="w-full pa-3"
              label="Comentários"
              v-model="row.comments"
              :rows="2"
            />
          </div>

          <div
            v-if="row.id != null"
            class="d-flex flex-row pa-3"
            style="background-color: rgba(0,0,0,.05)"
          >
            <OCapCont class="w-1/3" label="Criado">
              {{ row.createdAt | moment('DD/MM/YYYY HH:mm') }}
            </OCapCont>
            <OCapCont class="w-1/3" label="Alterado">
              {{ row.updatedAt | moment('DD/MM/YYYY HH:mm') }}
            </OCapCont>
            <OCapCont class="w-1/3" label="Login">
              {{ row.login }}
            </OCapCont>
          </div>
        </v-form>
      </v-card-text>
      <ODialogButtons
        class="pa-4"
        txtApply="Salvar"
        @apply="apply"
        @cancel="dismiss"
      />
    </v-card>
  </ODialog>
</template>

<script>
import OMoneyInput from 'oderon-vue/cpts/OMoneyInput.vue'
import { Keyboard, CostCenter, Org, Technician, Vehicle } from '../../../models'
import { isSet } from 'oderon-vue/utils.js'
import ValuesReferenceDialog from './ValuesReferenceDialog.vue'

function splitAndSort(items, prefix) {
  let removePrefix = (x) => {
    if (prefix != null) return x.replaceAll(prefix, '').trim()
    else return x.trim()
  }
  let byName = (a, b) => a.text.localeCompare(b.text)

  let ok = items
    .filter((x) => x.deletedAt == null)
    .map((x) => ({ value: x.id, text: removePrefix(x.name || x.code) }))
    .sort(byName)

  let deleted = items
    .filter((x) => x.deletedAt != null)
    .map((x) => ({
      value: x.id,
      text: '[REMOVIDO] ' + removePrefix(x.name || x.code)
    }))
    .sort(byName)

  return [...ok, { divider: true }, ...deleted]
}

export default {
  components: { OMoneyInput, ValuesReferenceDialog },
  data() {
    return {
      types: [
        { value: 'install', text: 'Instalação' },
        { value: 'remove', text: 'Retirada' },
        { value: 'intervention', text: 'Intervenção' }
      ],
      techs: [],
      costCenters: [],
      vehicles: [],

      historyId: null,
      keyboardId: null,
      row: {},
      isValid: false,

      isSet
    }
  },
  methods: {
    async open(historyId, keyboardId) {
      this.historyId = historyId
      this.keyboardId = keyboardId
      if (this.$refs.theForm) this.$refs.theForm.resetValidation()
      this.$refs.dialog.$loading(() => this.fetchAll())
      return this.$refs.dialog.$open()
    },
    async fetchAll() {
      await Promise.all([
        this.fetchTechs(),
        this.fetchCostCenters(),
        this.fetchVehicles(),
        this.fetchData()
      ])
    },
    async fetchTechs() {
      let items = await Technician.findAll({ includeInactive: true })
      this.techs = splitAndSort(items, 'Autorizado Oderon - ')
    },
    async fetchCostCenters() {
      let items = await CostCenter.findAll({ includeInactive: true })
      this.costCenters = splitAndSort(items, 'CC ')
    },
    async fetchVehicles() {
      let items = await Vehicle.findMini()
      let orgs = await Org.findAll()

      this.vehicles = items.map((x) => {
        let org = orgs.find((y) => y.id == x.org.id)
        let chips = []
        if (x.clientId == null) chips.push({ text: 'Desmobilizado', color: 'error' })
        if (org) chips.push({ text: org.name })
        return {
          value: x.id,
          text: x.code,
          chips
        }
      })
    },
    async fetchData() {
      if (this.historyId == null) {
        this.row = { keyboardId: this.keyboardId, timestamp: new Date() }
      } else {
        this.row = null
        let row = await Keyboard.findHistoryById(this.historyId, this.keyboardId)
        this.row = row
      }
    },
    apply() {
      this.$refs.theForm.validate()
      if (this.isValid) {
        this.$refs.dialog.$loading(async () => {
          await Keyboard.saveHistory(this.row)
          this.$snack('Salvo com sucesso')
          this.$refs.dialog.$apply(true) // reload na tela de baixo
        })
      }
    },
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    async showTechValues() {
      let dialog = this.$refs.valuesReferenceDialog
      let x = await dialog.openTech(this.row.technicianId)
      if (x != null) this.$set(this.row, 'techValue', x)
    },
    async showCostCenterValues() {
      let dialog = this.$refs.valuesReferenceDialog
      let x = await dialog.openCostCenter(this.row.costCenterId)
      if (x != null) this.$set(this.row, 'costCenterValue', x)
    }
  }
}
</script>

<style></style>
